import { compact } from 'lodash';
import React, { FC } from 'react';
import styled from 'styled-components';
import { ReconDetailsBankRecord } from '@melio/payments-recon-api-client-ts';
import { Tag } from '@tools/ui/components/common/Tag';
import { theme } from '@tools/ui-utils/theme.util';
import LinkToTransferSearch from './link-to-transfer-search';

type IProps = {
  bankRecord: ReconDetailsBankRecord;
};

const ClickableTag = styled(Tag)`
  cursor: pointer;

  &:hover {
    background-color: ${theme.colors.gray.grayLight};
  }
`;

const LinkToPayments: FC<React.PropsWithChildren<IProps>> = ({
  bankRecord
}) => {
  const paymentIds = compact([
    bankRecord.paymentId,
    ...(bankRecord.matchedCardPaymentIds || [])
  ]);

  if (!paymentIds?.length) {
    return null;
  }

  if (paymentIds.length === 1) {
    return (
      <LinkToTransferSearch filters={{ id: `PID ${paymentIds[0]}` }}>
        {paymentIds[0]}
      </LinkToTransferSearch>
    );
  }

  return (
    <LinkToTransferSearch filters={{ id: bankRecord.recordId }}>
      <ClickableTag>{paymentIds.length} Payments</ClickableTag>
    </LinkToTransferSearch>
  );
};

export default LinkToPayments;
